import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Notification from 'rc-notification';
import { savePDF } from '@progress/kendo-react-pdf';
import moment from 'moment';
import { Card, CardBody, CardTitle, Col,Button, Container, Row } from 'reactstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import SmallLoader from '../../../../shared/components/SmallLoader';
import history from '../../../App/History';
import SearchPositionTrackerTable from './SearchPositionTrackerTable';
// import { getSKUData, handleLoader } from '../../../../redux/actions/SKUAction';
import { getSearchPositionTrackerData, handleLoader } 
from '../../../../redux/actions/SearchPositionTrackerAction';
import { searchPositionTrackerTableHeader as tableHeaderData } from "../../helper";

const SearchPositionTracker = ({ dispatch }) => {
  const { t } = useTranslation('common');
  const location = useLocation();
  const navigate = useNavigate();
  
  const { searchPositionTrackerData, salesChannelFilterData, isLoading } = useSelector(
    ({ SearchPositionTrackerReducer, marketPlaceReducer }) =>
    ({      
      salesChannelFilterData: marketPlaceReducer.salesChannel,
      isLoading: SearchPositionTrackerReducer?.isLoading,
      searchPositionTrackerData: SearchPositionTrackerReducer.searchPositionTrackerData
    })
  );

  const previousMonthDate = new Date();
  previousMonthDate.setMonth(previousMonthDate.getMonth() - 3)

  const [selectedSKU, setSelectedSKU] = useState('');
  const [fromDate, setFromDate] = useState(previousMonthDate);
  const [toDate, setToDate] = useState(new Date());
  const [searchPositionTrackerdata, setSearchPositionTrackerdata] = useState([]);

  const skuOption = [];
  const productNameOptions = [];

  // implement PDF generateor //
  const container = React.useRef(null)
  const exportToPDF = () => {
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
     const btnUploadExcel = document.getElementById('dvFilter');
    //  const dvDownloadV = document.getElementById('dvDownload');
     btnUploadExcel.style.display = "none";  
    //  dvDownloadV.style.display = "none";   
    const element = container.current || document.body;
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: 5,
      fileName: `Search Position Tracker Report ${new Date().getFullYear()}`,
    })
    btnUploadExcel.style.display = "block"; 
    // dvDownloadV.style.display = "block"; 
  }

  const callApi = () => {   
    dispatch(handleLoader(true));   
    dispatch(getSearchPositionTrackerData(
        {            
            sku: selectedSKU && selectedSKU[0]?.value,
            fromDate: moment(fromDate).format('YYYY-MM-DD'),
            toDate: moment(toDate).format('YYYY-MM-DD')            
        }
    ));
  }

  const handleFromDateChange = (date) => {
    setFromDate(date);
  }

  const handleToDateChange = (date) => {
    setToDate(date);
  }

  const handleSKU = (value) => {
    setSelectedSKU(value)
  }

  const handleApplyDate = () => {
    const intFromDate = moment(fromDate).format('YYYYMMDD');
    const intToDate = moment(toDate).format('YYYYMMDD');
    if (intToDate > intFromDate) {
        callApi()
    }
    else {
        Notification.newInstance({}, (notification) => {
            notification.notice({
                content: 'To Date must be greater than From Date.'
            });
        });
    }
}

  const uploadExcel = () => {
    navigate('/report/searchPositionTracker/upload')
  }

  useEffect(() => {
    dispatch(handleLoader(true));
    // dispatch(getSKUData());
    callApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSearchPositionTrackerdata(searchPositionTrackerData && searchPositionTrackerData.modal 
      && searchPositionTrackerData.modal.data || []);
  }, [searchPositionTrackerData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    if (salesChannelFilterData && salesChannelFilterData.length > 0) {
      if (
        searchPositionTrackerData?.modal?.data?.length > 0
      ) {
        setSearchPositionTrackerdata(
          searchPositionTrackerData.modal.data.filter(
            x =>
              salesChannelFilterData?.length > 0 &&
              salesChannelFilterData?.find(y => (y?.value?.toString() || '')?.toLowerCase()
                === x[OptChennel]?.toLowerCase()),
          ),
        );
      }
    } else {
      setSearchPositionTrackerdata(searchPositionTrackerData && 
        searchPositionTrackerData.modal && searchPositionTrackerData.modal.data || []);
    }
  }, [searchPositionTrackerData, salesChannelFilterData])

  searchPositionTrackerData?.modal?.filters?.sort((a, b) => a.sortingOrder - b.sortingOrder).forEach((data) => {
    data.filterData.forEach((element) => {
        skuOption.push({
            value: element.key,
            label: element.shortValue
        });
    });
  });  


  let finalData = searchPositionTrackerdata ?? [];
  if (selectedSKU?.length) {
    const selected = selectedSKU?.reduce((acc, item) => {
      acc[item?.value] = item.value
      return acc
    }, {})
    finalData = searchPositionTrackerdata.filter(item => selected[item.sku])
  }


  return (
    <Container>
      <Card className="pb-3">
        <CardBody className="dashboard__card-widget card-shadow p-3">
          <CardTitle className="bold-text text-center" tag="h3">
          Search Position Tracker
          </CardTitle>          
        </CardBody>
      </Card>
      <CardBody>
        <Row>
          <Col md="3" className='pr-0'>
            <div className="form__form-group mb-0">
              <span className="form__form-group-label">SKU</span>
              <div className="form__form-group-field">
                <Select
                  value={selectedSKU}
                  options={skuOption}
                  clearable={false}
                  placeholder="Select"
                  className="sku-select_filter-250"
                  onChange={handleSKU}
                  classNamePrefix="react-select"  
                  isMulti                                           
                />                    
              </div>
            </div>
          </Col>
          <Col md="2">
            <div className="form__form-group mb-0">
              <span className="form__form-group-label">From Date</span>
              <div className="form__form-group-field">
              <div className="date-picker" style={{position: 'absolute', zIndex: 3}}>
                <DatePicker
                    className="form__form-group-datepicker"
                    selected={moment(fromDate).toDate()}
                    showPreviousMonths
                    onChange={handleFromDateChange}
                    dateFormat="MM/dd/yyyy"
                    dropDownMode="select"
                    popperPlacement="bottom"
                    withPortal={isMobileOnly}
                />
              </div>
              </div>
            </div>
          </Col>
          <Col md="2">
            <div className="form__form-group mb-0">
              <span className="form__form-group-label">To Date</span>
              <div className="form__form-group-field">
              <div className="date-picker" style={{position: 'absolute', zIndex: 3}}>
                <DatePicker
                    className="form__form-group-datepicker"
                    selected={moment(toDate).toDate()}
                    showPreviousMonths
                    onChange={handleToDateChange}
                    dateFormat="MM/dd/yyyy"
                    dropDownMode="select"
                    popperPlacement="bottom"
                    withPortal={isMobileOnly} 
                  //  style={{position: 'absolute', zIndex: 3}}                    
                />
              </div>
              </div>
            </div>
          </Col> 
          <Col md="1">
            <Button id='btnApply' className="btn btn-sm btn-primary" style={{marginTop: 26, marginLeft: 15, 
              color: 'white'}} title='Upload excel' onClick={handleApplyDate}>Apply</Button>
          </Col>  
          <Col md="4" align='right'>
            <Button id='btnUploadExcel' className="btn btn-sm btn-primary" style={{marginTop: 26, marginLeft: 15, 
              color: 'white'}} title='Upload excel' onClick={uploadExcel}>Upload</Button>
              <button className="btn btn-sm btn-primary apply-date-button" 
                type="button" style={{marginTop: 22, marginLeft: 15}} title='Export to pdf' 
                disabled={isLoading} onClick={exportToPDF}
                >Export pdf</button>
          </Col> 
          {/* <Col md='2'>
                </Col>            */}
        </Row>
        <div ref={container}>
        <Row className="product-table-wrap">        
            <Col sm="12">
              <CardBody>  
                {isLoading ? 
                    <div style={{ minHeight: '200px' }}
                        className="row align-items-center justify-content-center">
                        <SmallLoader loading={isLoading} />
                    </div> 
                  : <SearchPositionTrackerTable customClass="pt-0" reactTableData={{ tableHeaderData }}
                  data={finalData}
                // data={this.state.rows} 
                />
                }
              </CardBody>
            </Col>     

        </Row>
        </div>
      </CardBody>
    </Container>
  )
};

SearchPositionTracker.propTypes = {
  dispatch: PropTypes.func.isRequired,
}

export default connect(state => ({
  rtl: state.rtl,
}))(SearchPositionTracker);